/*
 * Manu AI (ex-AI Studio) → fiche produit (15/10/2026, v2 : devant + dos)
 * Si on arrive de Manu AI (?rx_studio=1) avec un logo (créé par Manu ou importé), on le dépose dans Teeinblue :
 *   1. template « Votre logo » (artwork CrossFit) ou « Ajout logo » (artwork running)
 *   2. devant : option « Design à l'avant » = « Votre logo », puis champ SVG « logo avant »
 *      dos    : champ SVG du logo arrière
 * Le fichier (SVG à la taille réelle, image intégrée) est préparé par assets/ai-studio.js et rangé
 * dans IndexedDB (base rxStudio, clé « logo »). Rien n'est envoyé ailleurs que dans le configurateur.
 * 20/10/2026 : couleur choisie dans Manu (sessionStorage rxStudioColor, posée par ai-studio-v13.js) →
 *   la fiche bascule d'abord sur la variante de cette couleur (mêmes autres options), puis dépose le logo.
 */
(function () {
  'use strict';
  if (!/[?&]rx_studio=1\b/.test(location.search)) return;

  var TEMPLATE_IDS = ['template-313151', 'template-933964'];      // Votre logo (CF), Ajout logo (running)
  var TEMPLATE_RE = /^(votre logo|ajout logo|your logo|add logo|tu logo|dein logo|il tuo logo)$/i;
  var FRONT_OPTION_ID = '26871091';                                 // « Design à l'avant » → Votre logo
  var MSG = {
    fr: 'Ton logo Manu AI est placé. Vérifie l’aperçu puis termine ta personnalisation.',
    en: 'Your Manu AI logo is in place. Check the preview, then finish customising.',
    es: 'Tu logo de Manu AI ya está colocado. Revisa la vista previa y termina la personalización.',
    de: 'Dein Manu-AI-Logo ist eingesetzt. Prüfe die Vorschau und schließe die Personalisierung ab.',
    it: 'Il tuo logo Manu AI è inserito. Controlla l’anteprima e completa la personalizzazione.'
  };
  var loc = (document.documentElement.lang || 'fr').slice(0, 2);

  function brief() { try { return JSON.parse(sessionStorage.getItem('rxStudioBrief')); } catch (e) { return null; } }
  function idbGet(key) {
    return new Promise(function (res) {
      if (!window.indexedDB) return res(null);
      var rq = indexedDB.open('rxStudio', 1);
      rq.onupgradeneeded = function () { rq.result.createObjectStore('kv'); };
      rq.onerror = function () { res(null); };
      rq.onsuccess = function () {
        try {
          var g = rq.result.transaction('kv').objectStore('kv').get(key);
          g.onsuccess = function () { rq.result.close(); res(g.result || null); };
          g.onerror = function () { res(null); };
        } catch (e) { res(null); }
      };
    });
  }
  function wait(test, ms) {
    return new Promise(function (res) {
      var t0 = Date.now();
      (function tick() { var v = test(); if (v) return res(v); if (Date.now() - t0 > ms) return res(null); setTimeout(tick, 250); })();
    });
  }
  function labelOf(input) {
    var l = input.id && document.querySelector('label[for="' + input.id + '"]');
    return l || input.closest('label') || input.parentElement;
  }
  function textOf(input) { return ((labelOf(input) || {}).innerText || '').replace(/\s+/g, ' ').trim(); }
  function choose(input) { if (input && !input.checked) labelOf(input).click(); }
  function visible(el) { return !!(el && el.offsetParent); }

  function logoTemplate() {
    var inputs = Array.prototype.slice.call(document.querySelectorAll('.tee-field--template input'));
    return inputs.filter(function (i) { return TEMPLATE_IDS.indexOf(i.value) > -1; })[0] ||
      inputs.filter(function (i) { return TEMPLATE_RE.test(textOf(i)); })[0] || null;
  }
  function vectorFields() {
    var all = Array.prototype.slice.call(document.querySelectorAll('.tee-field--vector')).filter(visible);
    var front = all.filter(function (f) { return /avant|front|delant|vorne|davanti/i.test(f.innerText); })[0] || null;
    var back = all.filter(function (f) { return f !== front; })[0] || null;
    return all.length ? { front: front, back: back } : null;
  }
  function putFile(field, svg, name) {
    var input = field && field.querySelector('input[type=file]');
    if (!input || typeof DataTransfer === 'undefined') return false;
    var dt = new DataTransfer();
    dt.items.add(new File([svg], name, { type: 'image/svg+xml' }));
    input.files = dt.files;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  function toast(text) {
    var d = document.createElement('div');
    d.setAttribute('role', 'status');
    d.textContent = text;
    d.style.cssText = 'position:fixed;left:50%;bottom:calc(20px + env(safe-area-inset-bottom));transform:translateX(-50%);z-index:60;max-width:min(520px,calc(100vw - 32px));background:#171717;color:#fff;font:600 14px/1.45 Montserrat,sans-serif;padding:14px 18px;border-radius:4px;box-shadow:0 12px 28px -10px rgba(0,0,0,.5)';
    document.body.appendChild(d);
    setTimeout(function () { d.style.transition = 'opacity .4s'; d.style.opacity = '0'; setTimeout(function () { d.remove(); }, 450); }, 6000);
  }

  // Une face : option « Design à l'avant » pour le devant, puis le fichier dans le champ SVG de la face
  function putFace(side, f) {
    if (side === 'front') {
      var opt = document.querySelector('.tee-field--additional_option input[value="' + FRONT_OPTION_ID + '"]') ||
        Array.prototype.slice.call(document.querySelectorAll('.tee-field--additional_option input')).filter(function (i) { return TEMPLATE_RE.test(textOf(i)); })[0];
      choose(opt);
    }
    return wait(function () { var fl = vectorFields(); return fl && fl[side]; }, 5000).then(function (field) {
      if (!field) return null;
      return putFile(field, f.svg, 'manu-ai-' + side + '-' + (f.cm || []).join('x') + '.svg') ? field : null;
    });
  }

  // Couleur choisie dans Manu → variante de cette couleur (une seule fois, valable 30 min). true = on recharge.
  function norm(x) { return String(x || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase(); }
  function colorVariant() {
    var c; try { c = JSON.parse(sessionStorage.getItem('rxStudioColor')); } catch (e) { c = null; }
    var m = location.pathname.match(/^(.*\/products\/[^\/]+)/);
    if (!c || !m || !window.fetch || Date.now() - (c.at || 0) > 30 * 60 * 1000) return Promise.resolve(false);
    sessionStorage.removeItem('rxStudioColor');
    var want = [norm(c.k), norm(c.n)].filter(Boolean);
    return fetch(m[1] + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (p) {
      var vs = p.variants || [], oi = -1;
      (p.options || []).forEach(function (o, i) { if (oi < 0 && /couleur|colou?r|farbe|colore/i.test(typeof o === 'string' ? o : o.name)) oi = i; });
      if (oi < 0) return false;
      var vid = (/[?&]variant=(\d+)/.exec(location.search) || [])[1];
      var cur = vs.filter(function (v) { return String(v.id) === vid; })[0] || vs.filter(function (v) { return v.available; })[0] || vs[0];
      if (!cur || want.indexOf(norm(cur.options[oi])) > -1) return false;
      var ok = vs.filter(function (v) { return want.indexOf(norm(v.options[oi])) > -1; });
      var same = function (v) { return v.options.every(function (x, i) { return i === oi || x === cur.options[i]; }); };
      var target = ok.filter(function (v) { return same(v) && v.available; })[0] || ok.filter(function (v) { return v.available; })[0] || ok.filter(same)[0] || ok[0];
      if (!target) return false;
      var u = new URL(location.href); u.searchParams.set('variant', target.id);
      location.replace(u.toString());
      return true;
    }).catch(function () { return false; });
  }

  function run() {
    var b = brief();
    if (!b || (b.path !== 'story' && b.path !== 'own') || !b.logo) return;
    var doneKey = 'rxStudioLogoDone';
    if (sessionStorage.getItem(doneKey) === String(b.logo.at)) return;   // déjà déposé (rechargement)
    idbGet('logo').then(function (logo) {
      if (!logo || logo.at !== b.logo.at) return null;
      // v2 : { faces: { front: { svg, cm }, back: { svg, cm } } } ; v1 : { side, svg, cm }
      var faces = logo.v === 2 ? logo.faces : (logo.svg ? (function () { var o = {}; o[logo.side === 'back' ? 'back' : 'front'] = { svg: logo.svg, cm: logo.cm }; return o; })() : null);
      if (!faces || (!faces.front && !faces.back)) return null;
      return wait(logoTemplate, 20000).then(function (tpl) {
        if (!tpl) return null;                                       // produit sans template logo : on laisse le configurateur tel quel
        choose(tpl);
        return wait(vectorFields, 8000).then(function (fields) {
          if (!fields) return null;
          var first = null;
          var chain = Promise.resolve();
          ['front', 'back'].forEach(function (side) {
            if (!faces[side] || !faces[side].svg) return;
            chain = chain.then(function () { return putFace(side, faces[side]).then(function (field) { if (field && !first) first = field; }); });
          });
          return chain.then(function () {
            if (!first) return null;
            sessionStorage.setItem(doneKey, String(b.logo.at));
            setTimeout(function () { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 600);
            toast(MSG[loc] || MSG.fr);
            return true;
          });
        });
      });
    });
  }

  function start() { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run(); }
  colorVariant().then(function (reload) { if (!reload) start(); }, start);
})();
